import React from "react";
import { EditPage } from "@equipedigitalfloripa/ed-cms/components";
import * as especialidadeApi from "../api/faq";
import { useSelector } from "react-redux";

const EditFaq = ({ edit }) => {
  const translations = useSelector((state) => state.translations.translations);
  const faqTranslations = translations["system-faq"];

  const selectedData = [
    {
      name: "_id",
      type: "hidden",
      title: "Id",
    },
    {
      name: "pergunta",
      type: "text",
      title: "Pergunta",
      validation: {
        required: true,
      },
    },
    {
      name: "resposta",
      type: "tiny",
      title: "Resposta",
      validation: {
        required: true,
      },
    },
  ];
  return (
    <EditPage
      selectedData={selectedData}
      addFunction={especialidadeApi.addItem}
      fetchFunction={especialidadeApi.fetchItem}
      editFunction={especialidadeApi.editItem}
      edit={edit}
      url="faq"
    />
  );
};

export default EditFaq;
